module.exports = __webpack_public_path__ + "img/w3_circle_trash_light.03d36623.png";